'use client';

import { config, library } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import {
	faAngleDown,
	faArrowLeft,
	faArrowRight,
	faBadgeCheck,
	faBars,
	faChevronDown,
	faClose,
	faComputer,
	faEarthEurope,
	faEnvelope,
	faGlobe,
	faInfoCircle,
	faArrowRightLong,
	faLocationDot,
	faPhone,
} from '@fortawesome/pro-regular-svg-icons';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faQuoteLeft, faQuotes } from '@fortawesome/pro-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { ReactNode } from 'react';

config.autoAddCss = false;

library.add(
	faQuoteLeft,
	faChevronRight,
	faQuotes,
	faArrowRightLong,
	faComputer,
	faGlobe,
	faLocationDot,
	faBadgeCheck,
	faEarthEurope,
	faArrowRight,
	faArrowLeft,
	faClose,
	faChevronDown,
	faAngleDown,
	faBars,
	faChevronDown,
	faInfoCircle,
	faPhone,
	faEnvelope,
	fab
);

export default function IconProvider({ children }: { children: ReactNode }) {
	return <>{children}</>;
}
